import { SpicyButton, Text } from "@/components/customComponents";
import { LocalizedLink } from "@/components/LocalizedLink/LocalizedLink";
import Trans from "@/components/Trans/Trans";

export const StartChattingButton = () => {
  return (
    <SpicyButton as={LocalizedLink} variant="primary_large" color="primary_strong" to="/">
      <Text b variant={"md"} type="white">
        <Trans i18nKey="subscription:checkoutSuccess.startChatting" />
      </Text>
    </SpicyButton>
  );
};
